import React from "react";
import ChangePasswordComponent from "../../components/pages/VehicleInsurenceComponent/ChangePasswordComponent";

const ChangePasswordPage = () => {
  return <ChangePasswordComponent />;
};

export default ChangePasswordPage;
